import { Outlet, Link, useLocation } from "react-router-dom";
import { Box, Flex, HStack, Text } from "@chakra-ui/react";
import { Plane } from "lucide-react";

export function Layout() {
  const location = useLocation();
  const isDashboard = location.pathname === "/";
  const isApproval = location.pathname === "/approval";

  return (
    <Flex direction="column" h="full">
      <Box
        as="header"
        px="4"
        py="3"
        borderBottomWidth="1px"
        borderColor="border"
        bg="bg.subtle"
      >
        <Flex align="center" gap="6">
          <Link to="/">
            <HStack gap="2" fontWeight="bold" fontSize="lg">
              <Plane style={{ height: 20, width: 20 }} />
              <Text>Drone Fleet</Text>
            </HStack>
          </Link>
          <HStack as="nav" gap="4" fontSize="sm">
            <Link to="/">
              <Text
                color={isDashboard ? "fg" : "fg.muted"}
                _hover={{ color: "fg" }}
                transition="colors 0.2s"
              >
                Dashboard
              </Text>
            </Link>
            <Link to="/approval">
              <Text
                color={isApproval ? "fg" : "fg.muted"}
                _hover={{ color: "fg" }}
                transition="colors 0.2s"
              >
                Approval
              </Text>
            </Link>
          </HStack>
        </Flex>
      </Box>
      <Box
        as="main"
        flex="1"
        p={isDashboard ? "0" : "4"}
        overflow={isDashboard ? "hidden" : "auto"}
      >
        <Outlet />
      </Box>
    </Flex>
  );
}
